import { createRouter, createWebHistory } from 'vue-router'
import Cotizador from './components/views/Cotizador.vue'
import TipoPlanes from './components/views/TipoPlanes.vue'
import Planes from './components/views/Planes.vue'
import DatosCompra from './components/views/DatosCompra.vue'
import Pago from './components/views/DetallePago.vue'
import Vaucher from './components/views/Vaucher.vue'
import Confirmar from './components/views/Confirmar.vue'
import PagoExterno from './components/views/PagoExterno.vue'

const routes = [
  {
    path: '/',
    name: 'cotizador',
    component: Cotizador
  },
  {
    path: '/tipoPlanes',
    name: 'tipoPlanes',
    component: TipoPlanes
  },
  {
    path: '/planes',
    name: 'planes',
    component: Planes
  },
  {
    path: '/datosCompra',
    name: 'datosCompra',
    component: DatosCompra
  },
  {
    path: '/pago',
    name: 'pago',
    component: Pago
  },
  {
    path: '/voucher/:id',
    name: 'voucher',
    component: Vaucher
  },
  {
    path: '/confirmar/:transactionId',
    name: 'confirmar',
    component: Confirmar
  },
  {
    path: '/pago-externo',
    name: 'PagoExterno',
    component: PagoExterno
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router